package org.gstechnovos.jexonplastech.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import org.gstechnovos.jexonplastech.components.cms.CmsSection
import org.gstechnovos.jexonplastech.components.cms.DynamicSectionRenderer
import org.gstechnovos.jexonplastech.components.layouts.PageLayout
import org.gstechnovos.jexonplastech.components.widgets.BackToTopButton

@OptIn(DelicateApi::class)
@Page
@Composable
fun HomePage() {

    // simulated CMS payload for the Home Page
    val pageSections: List<CmsSection> = listOf(
        CmsSection.HomeHeroSection(),
        CmsSection.HomeCompanyOverviewSection(),
        CmsSection.HomeFeaturedCategoriesSection(),
        CmsSection.HomeQualityStandardsSection(),
        CmsSection.HomeGlobalCtaSection(),
    )

    PageLayout {
        Column(
            modifier = Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }

        BackToTopButton()
    }
}
